import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component,  Inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID, SimpleChanges, input } from '@angular/core';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { IncItem } from '@app/models/hotels/IncItem';
import { Partner } from '@app/models/partner/IPartner';
import { AcvisService } from '@app/services/acvis.service';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import moment from 'moment';
import { Subject, takeUntil } from 'rxjs';
interface Item {
    code: string;
    name: string;
    bestPricePerPerson: {
        currency: string;
        value: string;
    }
}
@Component({
    selector: 'clever-flexibel',
    templateUrl: './flexibel.component.html',
    styleUrls: ['./flexibel.component.scss'],
    standalone: false
})
export class FlexibelComponent implements OnInit, OnDestroy, OnChanges {
    @Input() tourOperatorList: Item[];
    readonly inclusiveListExt = input<any[]>(undefined);
    readonly context = input<string>(undefined);
    protected unsubscribe$ = new Subject();
    isBrowser: boolean = false;
    currentPartner: Partner;
    showFTS: boolean = false;
    showFTU: boolean = false;
    flexextraCS: boolean = false;
    flexextraCSChecked: boolean = false;
    flexextraCSVal: any;
    flexextraFS: boolean = false;
    flexextraFSChecked: boolean = false;
    flexextraFSVal: any;
    flexextraCR: boolean = false;
    flexextraCRChecked: boolean = false;
    flexextraCRVal: any;
    start: string;
    end: string;
    mode: string;
    flexs = {
        fts: {
            code: 'FTS',
            name: 'kostenlos stornierbar',
            checked: false,
            ops: []
        },
        ftu: {
            code: 'FTU',
            name: 'günstig stornierbar',
            checked: false,
            ops: []
        }
    };

    specials: IncItem[] = [];
    selectedData: IncItem[] = [];
    ops: { tourOperatorList: any[] };

    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected acvisService: AcvisService,
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef,
        protected guardService: AuthGuardService
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initPartner();

            const inclusiveListExt = this.inclusiveListExt();
            for (let i = 0; i < inclusiveListExt?.length; i++) {
                switch (inclusiveListExt[i].code) {
                    case 'CS':
                        this.flexextraCS = true;
                        this.flexextraCSVal = inclusiveListExt[i];
                        break;
                    case 'FS':
                        this.flexextraFS = true;
                        this.flexextraFS = inclusiveListExt[i];
                        break;
                    case 'CR':
                        this.flexextraCR = true;
                        this.flexextraCR = inclusiveListExt[i];
                        break;

                    default:
                        break;
                }
            }
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['tourOperatorList'].currentValue?.length > 0) {
            this.tourOperatorList = changes['tourOperatorList'].currentValue;
            if (this.ops?.tourOperatorList?.length > 0) {
                // this.checkShowDatas(this.ops?.tourOperatorList);
                this.checkSpecials(this.ops?.tourOperatorList);
            }
        }
    }

    initPartner(): void {
        this.guardService.getPartner$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((part: Partner) => {
            if (part?.agenturen?.length > 0) {
                this.currentPartner = part;
                const tours = [];
                for (let i = 0; i < part?.agenturen.length; i++) {
                    tours.push(part?.agenturen[i].code)
                }
                this.initFilterSub(tours);
            }
        });
    }

    initFilterSub(tours): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((filter: ParamFilters) => {
            if (filter?.reisezeitraumResult?.start?.length > 0) {
                this.mode = filter.productType;
                this.start = filter.reisezeitraumResult.start;
                this.end = filter.reisezeitraumResult.end;
                this.selectedData = filter.inclusiveListServiceOffer?.length > 0 ? filter.inclusiveListServiceOffer : [];
                // this.initFlex(tours);
                this.checkIfCheckedExtra(filter);
            }
        });
    }

    checkIfCheckedExtra(filter) {
        for (let i = 0; i < filter?.inclusiveList?.length; i++) {
            switch (filter.inclusiveList[i].code) {
                case 'CS':
                    this.flexextraCSChecked = true;
                    break;
                case 'FS':
                    this.flexextraFSChecked = true;
                    break;
                case 'CR':
                    this.flexextraCRChecked = true;
                    break;

                default:
                    break;
            }
        }
    }

    initFlex(tours): void {
        this.acvisService.request({ tourcodes: tours }, 'getoprspecflex').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(ops => {
            this.ops = ops;
            if (ops?.tourOperatorList?.length > 0) {
                // this.checkShowDatas(ops.tourOperatorList);
                this.checkSpecials(ops.tourOperatorList);
            }
        });
    }

    async checkShowDatas(tours) {
        this.showFTU = false;
        this.showFTS = false;
        if (tours?.length > 0) {
            if (tours?.length > 0) {
                const now = moment().format('YYYY-MM-DD');
                for (let i = 0; i < tours.length; i++) {
                    if (
                        now >= moment(tours[i].toma?.bookinkzeitraumvon).format('YYYY-MM-DD') &&
                        (
                            now <= moment(tours[i].toma?.bookinkzeitraumbis).format('YYYY-MM-DD') ||
                            !tours[i].toma?.bookinkzeitraumbis
                        ) &&
                        this.start >= moment(tours[i].toma?.reisezeitraumvon).format('YYYY-MM-DD') &&
                        (
                            this.start <= moment(tours[i].toma?.reisezeitraumbis).format('YYYY-MM-DD') ||
                            !tours[i].toma?.bookinkzeitraumbis
                        ) && this.checkOpCode(tours[i].code)
                    ) {
                        if (tours[i].toma?.actions?.length > 0) {
                            for (let s = 0; s < tours[i].toma.actions.length; s++) {
                                if ((tours[i].toma?.actions[s].flexType === 'kostenlos' &&
                                    tours[i].toma?.actions[s]?.travelType === this.mode) ||
                                    tours[i].toma?.actions[s]?.travelType === 'beides') {
                                    this.showFTS = true;
                                    this.flexs.fts.ops.push(tours[i].code);
                                    s = tours[i].toma.actions.length;
                                } else if ((tours[i].toma?.actions[s].flexType === 'gunstig' &&
                                    tours[i].toma?.actions[s]?.travelType === this.mode) ||
                                    tours[i].toma?.actions[s]?.travelType === 'beides') {
                                    this.showFTU = true;
                                    this.flexs.ftu.ops.push(tours[i].code);
                                    s = tours[i].toma.actions.length;
                                }
                            }
                        }
                    }
                }
            }
        }
        this.checkIfCheckedFTU();
        this.checkIfCheckedFTS();
        this.cdr.detectChanges();
    }

    checkOpCode(code): boolean {
        if (this.tourOperatorList?.length > 0) {
            for (let i = 0; i < this.tourOperatorList.length; i++) {
                if (this.tourOperatorList[i].code === code) {
                    return true;
                }
            }
        }
        return !this.tourOperatorList;
    }

    async checkIfCheckedFTS() {
        this.flexs.fts.checked = false;
        for (let i = 0; i < this.selectedData.length; i++) {
            if (this.selectedData[i].code === 'FTS') {
                this.flexs.fts.checked = true;
                i = this.selectedData.length;
            }
        }
        this.cdr.detectChanges();
    }

    async checkIfCheckedFTU() {
        this.flexs.ftu.checked = false;
        for (let i = 0; i < this.selectedData.length; i++) {
            if (this.selectedData[i].code === 'FTU') {
                this.flexs.fts.checked = true;
                i = this.selectedData.length;
            }
        }
        this.cdr.detectChanges();
    }

    async checkIfCheckedSpecials() {
        for (let i = 0; i < this.selectedData.length; i++) {
            for (let j = 0; j < this.specials.length; j++) {
                if (this.selectedData[i].code === this.specials[j].code) {
                    this.specials[j].checked = true;
                    i = this.selectedData.length;
                }
            }
        }
        this.cdr.detectChanges();
    }

    async checkSpecials(specialtours) {
        this.specials = [];
        this.cdr.detectChanges();
        if (specialtours?.length > 0) {
            const now = moment().format('YYYY-MM-DD');
            for (let i = 0; i < specialtours.length; i++) {
                for (let s = 0; s < specialtours[i].specials?.specials?.length; s++) {
                    const spec = specialtours[i].specials?.specials[s];
                    if (
                        now >= moment(spec?.bookinkzeitraumvon).format('YYYY-MM-DD') &&
                        (
                            now <= moment(spec?.bookinkzeitraumbis).format('YYYY-MM-DD') ||
                            !spec?.bookinkzeitraumbis
                        ) &&
                        ((this.start >= moment(spec?.reisezeitraumvon).format('YYYY-MM-DD') &&
                            (
                                this.start <= moment(spec?.reisezeitraumbis).format('YYYY-MM-DD') ||
                                !spec?.bookinkzeitraumbis
                            )) || (this.start < moment(spec?.reisezeitraumvon).format('YYYY-MM-DD') && this.end > moment(spec?.reisezeitraumvon).format('YYYY-MM-DD'))) && this.checkOpCode(specialtours[i].code)
                    ) {
                        if (spec?.travelType === this.mode || spec?.travelType === 'all') {
                            if (this.specials?.length > 0) {
                                let found = false;
                                for (let l = 0; l < this.specials.length; l++) {
                                    if (this.specials[l].code === spec.specialType) {
                                        this.specials[l].ops.push(specialtours[i].code);
                                        found = true;
                                    }
                                }

                                if (!found) {
                                    this.specials.push({
                                        code: spec.specialType,
                                        name: spec.specialType === 'COR' ? 'Corona Reiseschutz' : spec.name,
                                        tooltip: spec.text,
                                        checked: false,
                                        ops: [specialtours[i].code]
                                    });
                                    this.cdr.detectChanges();
                                }
                            } else {
                                this.specials.push({
                                    code: spec.specialType,
                                    name: spec.specialType === 'COR' ? 'Corona Reiseschutz' : spec.name,
                                    tooltip: spec.text,
                                    checked: false,
                                    ops: [specialtours[i].code]
                                });
                                this.cdr.detectChanges();
                            }
                        }
                        s = specialtours[i].specials?.specials?.length;
                    }
                }
            }
        }
        this.checkIfCheckedSpecials();
        this.cdr.detectChanges();
    }

    async onChange(item) {
        item.checked = !item.checked;
        if (item.checked) {
            this.selectedData.push(item);
        } else {
            for (let i = 0; i < this.selectedData.length; i++) {
                if (this.selectedData[i].code === item.code) {
                    this.selectedData.splice(i, 1);
                    i = this.selectedData.length + 1;
                }
            }
        }
        this.hotelService.inclusiveListServiceOffer(this.selectedData);
    }

    async checkflexextraCS() {
        this.flexextraCSChecked = !this.flexextraCSChecked;
        this.hotelService.inclusiveList({ code: 'CS', name: 'flexibel stornierbar' }, this.flexextraCSChecked, true);
    }

    async checkflexextraFS() {
        this.flexextraFSChecked = !this.flexextraFSChecked;
        this.hotelService.inclusiveList({ code: 'FS', name: 'kostenfrei stornierbar' }, this.flexextraFSChecked, true);
    }

    async checkflexextraCR() {
        this.flexextraCRChecked = !this.flexextraCRChecked;
        this.hotelService.inclusiveList({ code: 'CR', name: 'Corona-Reiseschutz' }, this.flexextraCRChecked, true);
    }
}
